import { LOCAL_STORAGE } from "utils/constants";

/**
 * Handles user logout by clearing all authentication-related data from localStorage
 * and redirecting to the login page.
 * This function is used in API interceptors and can be called from anywhere in the app.
 */
export const clearLocalStorage = () => {
  localStorage.removeItem("loginTime");
  localStorage.removeItem("authorization");
  localStorage.removeItem("role");
  localStorage.removeItem("modules");
  localStorage.removeItem("client");
  localStorage.removeItem("user_data");
  localStorage.removeItem("IssLoging");
  localStorage.removeItem(LOCAL_STORAGE.FILTERS);
  localStorage.removeItem(LOCAL_STORAGE.SORT_BY);
};
